import { Api } from 'models/services/api';
import { ReadPosSystemsQuery } from 'models/services/graphql';

import { PosSystemCollectionData } from '../collection';

type DataToRead = {
  nextToken?: string;
};

const RequestQuery = `
  query PosSystems($nextToken: String) {
    ${ReadPosSystemsQuery}
  }
`;

type ResponseData = {
  data: {
    readPosSystems: PosSystemCollectionData;
  }
};

class ReadCollectionGql {

  readonly result?: PosSystemCollectionData;
  private readonly api: Api<ResponseData>;

  constructor() {
    this.api = new Api<ResponseData>(RequestQuery);
  }

  async fetch(data: DataToRead = {}): Promise<this> {
    const api = await this.api.fetch({ variables: data });
    if (!api.response) throw new Error('invalid response');
    const result = api.response.data.readPosSystems;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, result, api });
  }

}

export { ReadCollectionGql };
